import { Col, Row } from "react-bootstrap";

import { ErrorAlert, Loading, PageHeader, PlanLock } from "../../layout/secure/common";
import { featureIncluded, PREMIUM_FEATURES } from "../../utils/premium-features";
import useUsage from "./use-usage";
import WebhookSettings from "./webhook-settings";
import WordPressInstallations from "./wordpress-installations";

function Settings() {
  const { data, error, load } = useUsage();
  if (!data && !error) return <Loading label="Loading Survey settings" />;
  const routing = data?.routing || {};
  const branding = data?.branding || {};
  const customBranding = featureIncluded(data, "customBranding");
  const customRouting = featureIncluded(data, "customRouting");
  return (
    <>
      <PageHeader title="Settings" description="Review standalone routing, branding, and plan-controlled Survey features." />
      <ErrorAlert error={error} onRetry={load} />
      <Row className="g-4">
        <Col lg="6">
          <section className="fera-panel h-100">
            <div className="fera-panel-heading">
              <div><p className="fera-eyebrow">Routing</p><h2>Authentication and home</h2></div>
              {customRouting
                ? <span className="text-muted small">Beyond feature</span>
                : (
                  <PlanLock title={PREMIUM_FEATURES.customRouting.description}>
                    {PREMIUM_FEATURES.customRouting.label}
                  </PlanLock>
                )}
            </div>
            <dl className="fera-properties">
              <div><dt>Login URL</dt><dd>{routing.loginUrl || "https://auth.surveys.feradel.com"}</dd></div>
              <div><dt>Application URL</dt><dd>{routing.homeUrl || "https://surveys.feradel.com"}</dd></div>
              <div><dt>Management</dt><dd>{routing.readOnly ? "License-controlled" : "FeraMatters managed"}</dd></div>
            </dl>
            <p className="text-muted mb-0">
              {customRouting
                ? "Your Beyond plan includes custom authentication and application routing. Routing remains License-controlled."
                : "Custom authentication and application routing requires Beyond. Standalone routing is protected server-side."}
            </p>
          </section>
        </Col>
        <Col lg="6">
          <section className="fera-panel h-100">
            <div className="fera-panel-heading">
              <div><p className="fera-eyebrow">Branding</p><h2>Survey identity</h2></div>
              {customBranding
                ? <span className="text-muted small">Complete and Beyond feature</span>
                : (
                  <PlanLock title={PREMIUM_FEATURES.customBranding.description}>
                    {PREMIUM_FEATURES.customBranding.label}
                  </PlanLock>
                )}
            </div>
            <dl className="fera-properties">
              <div><dt>Light-background logo</dt><dd>{branding.smallLogo || "Feradel fallback"}</dd></div>
              <div><dt>Dark-background logo</dt><dd>{branding.smallLogoLight || "Feradel fallback"}</dd></div>
            </dl>
            <p className="text-muted mb-0">
              {customBranding
                ? "Your plan includes custom Survey branding."
                : "Custom Survey branding requires Complete or Beyond; Feradel branding is used on this plan."}
            </p>
          </section>
        </Col>
      </Row>
      <WordPressInstallations />
      <WebhookSettings usage={data} />
    </>
  );
}

export default Settings;
